import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { MapDetailDto } from '../models/models';
import { AppState } from '../redux/app.state';
import { fetchMap } from '../redux/maps/map.actions';
import { MapAction } from '../redux/maps/map.types';
import { AppThunkDispatch } from '../redux/app.types';

export function useStateMap(
	mapId: string | undefined,
	dispatch: AppThunkDispatch<MapAction>
): MapDetailDto | undefined {
	const loadedMaps: { [mapId: string]: MapDetailDto } = useSelector(
		(state: AppState) => state.maps.loadedMaps
	);

	const [map, setMap] = useState<MapDetailDto | undefined>(
		mapId ? loadedMaps[mapId] : undefined
	);

	useEffect(() => {
		if (!mapId) {
			setMap(undefined);
			return;
		}
		if (map && map.id === mapId) return;

		if (isMapLoaded()) {
			setMap(loadedMaps[mapId]);
			return;
		}

		dispatch(fetchMap(mapId));
	}, [mapId]);

	useEffect(() => {
		if (!mapId || !isMapLoaded()) return;
		const stateMap: MapDetailDto = loadedMaps[mapId];
		if (!map || stateMap.id !== map.id) {
			setMap(stateMap);
		}
	}, [loadedMaps]);

	function isMapLoaded(): boolean {
		return mapId !== undefined ? loadedMaps[mapId] !== undefined : false;
	}

	return map;
}
